import {
  LogoBackstageColored,
  LogoDatadogColored,
  LogoGcpColored,
  LogoMsTeamsColored,
  LogoServicenowColored,
} from "components/icons/generated";
import { getDocsUrl } from "utils/getDocsUrl";

import { IntegrationView } from "../types";

enum IntegrationId {
  BACKSTAGE = "backstage",
  DATADOG = "datadog",
  GCP = "gcp",
  SERVICENOW = "servicenow",
  TEAMS = "teams",
}

export const integrationIds = Object.values(IntegrationId).sort((a, b) => a.localeCompare(b));
export const isValidIntegrationId = (id: string | undefined): id is IntegrationId => {
  return integrationIds.includes(id as IntegrationId);
};

export const getIntegrationById = (id: IntegrationId): IntegrationView => {
  const integrationView = integrationRegistry[id];
  if (!integrationView) {
    throw new Error(`Integration with id ${id} not found`);
  }
  return integrationView;
};

const integrationRegistry: Record<IntegrationId, IntegrationView> = {
  [IntegrationId.BACKSTAGE]: {
    id: "backstage",
    name: "Backstage",
    description: "Bring Spacelift's stacks and runs to your developer portal.",
    icon: LogoBackstageColored,
    isNew: true,
    docsLink: getDocsUrl("/integrations/external-integrations/backstage"),
    hasViewScreen: true,
    type: "idp",
    page: () => import("./Backstage"),
    hasSearch: false,
  },
  [IntegrationId.DATADOG]: {
    id: "datadog",
    name: "Datadog",
    description: "Monitor your applications with Datadog.",
    icon: LogoDatadogColored,
    docsLink: getDocsUrl("/integrations/observability/datadog"),
    type: "observability",
  },
  [IntegrationId.GCP]: {
    id: "gcp",
    name: "Google Cloud Platform",
    description: "Authenticate Spacelift to GCP with federated identity.",
    icon: LogoGcpColored,
    docsLink: getDocsUrl("/integrations/cloud-providers/oidc/gcp-oidc"),
    type: "cloud",
  },
  [IntegrationId.SERVICENOW]: {
    id: "servicenow",
    name: "ServiceNow",
    description: "Tie Spacelift's activity to ITSM workflows in ServiceNow.",
    icon: LogoServicenowColored,
    isNew: true,
    docsLink: getDocsUrl("/integrations/external-integrations/servicenow"),
    hasViewScreen: true,
    type: "idp",
    page: () => import("./ServiceNow"),
    detailsPage: () => import("./ServiceNow/ItemPage"),
    hasSearch: false,
  },
  [IntegrationId.TEAMS]: {
    id: "teams",
    name: "Microsoft Teams",
    description: "Notify Teams channels on infrastructure changes or approvals.",
    icon: LogoMsTeamsColored,
    docsLink: getDocsUrl("/integrations/chatops/msteams"),
    type: "communication",
  },
};
